"use client";
import { createContext } from "react";
import { Enumerations } from "@/types/enumerations";

export const EnumerationsContext = createContext<Enumerations>({
  agreements: [],
  attachments: [],
  bankCodes: [],
  degreeBefores: [],
  degreeAfters: [],
  executiveRoles: [],
  suppliers: [],
  products: [],
  tariffs: [],
  commodities: [],
  depositFrequencies: [],
  processes: [],
  priceLists: [],
  legalInstitutes: [],
  countries: [],
  czechCountryId: "",
  ecoTypes: [],
  bonuses: [],
  supplyPointUsages: [],
  serviceAttributes: [],
  paymentInfos: [],
  terminationTypes: [],
  determinationReasons: [],
  processReasons: [],
  temporalities: [],
  gasAppliances: [],
  powerAppliances: [],
  processSpecification: [],
  circuitBreakers: [],
  measurementTypes: [],
  changeOfCustomerReason: [],
  distributionAreas: [],
  distributionGrids: [],
  plannedConsumptions: [],
  serviceProducts: [],
  cardAuthorizationMethods: [],
  bonusTypes: [],
});
